export class Tramite {
  tipos_tramite: Array<any> = [];
  tramite_seleccionado: any;
}
